import { useMemo } from 'react';
import { multiLevelTLDs } from '../utils/multiLevelTLDs';

const useGetSubdomain = () => {
	const hostname = window.location.hostname;
	const fashSubdomain = hostname.split('.')[0];
	const domainParts = hostname.split('.');

	const tld = domainParts.slice(-2).join('.');
	const isMultiLevelTLD = multiLevelTLDs.includes(tld);

	let customDomain;
	if (isMultiLevelTLD) {
		customDomain = domainParts[domainParts.length - 3];
	} else {
		customDomain = domainParts[domainParts.length - 2];
	}

	const isCustomDomain = !['mima.style', 'localhost'].some(domain =>
		hostname.includes(domain)
	);

	const subdomain = useMemo(() => {
		if (isCustomDomain) {
			return customDomain;
		}

		return fashSubdomain;
	}, [isCustomDomain, customDomain, fashSubdomain]);

	return { subdomain };
};


export default useGetSubdomain;
